import { useNavigate, useParams } from 'react-router-dom';
import { Center, Loader } from '@mantine/core';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { ROUTES } from '@dealstack/frontend/app/pages/Routing/routes';
import { useDocumentTemplateQuery } from '@dealstack/frontend/app/pages/DocumentTemplates/api/useDocumentTemplateQuery';
import { StaticPdfTemplateEditor } from '@dealstack/frontend/app/pages/DocumentTemplates/StaticPdfTemplate/StaticPdfTemplateEditor';
import { Page } from './EditDocumentTemplate.styled';

export const EditDocumentTemplate = () => {
	const { templateId } = useParams<{ templateId: string }>();
	const navigate = useNavigate();
	const query = useDocumentTemplateQuery(templateId);

	if (!query.data) {
		return (
			<Page>
				<Icon variant="arrow-left" size="vlg" onClick={() => navigate(ROUTES.TEMPLATES)} />
				<Center h="60vh">
					<Loader />
				</Center>
			</Page>
		);
	}

	// Keyed by templateId so a route change re-seeds the editor.
	return (
		<Page>
			<StaticPdfTemplateEditor key={templateId} template={query.data} />
		</Page>
	);
};
